// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"product-lexicon-module--mainContent--2ximH","sectionTitle":"product-lexicon-module--sectionTitle--1pJAe","uiTerms":"product-lexicon-module--uiTerms--3eq-_"};